import EmptyStateAsset from '@/assets/emptyState/emptyStateAsset.svg?react'
import { CardContent } from '@/components/ui/card'
import useMobileMediaQuery from '@/hooks/useMobileMediaQuery'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

export const EmptyState = ({ text }: { text?: string }) => {
  const isMobile = useMobileMediaQuery()
  return (
    <CardContent className="lg:h-3/4 flex justify-center items-center">
      <div
        id="emptyState"
        className="flex flex-col justify-center items-center p-8"
      >
        <EmptyStateAsset
          className="w-full h-full"
          color={SocialMirrorPalette.neutralColor}
        />

        <p
          className={`text-base font-medium text-center neutral-500 text-textAccent tracking-wider ${
            isMobile && 'text-xs'
          }`}
        >
          {text}
        </p>
      </div>
    </CardContent>
  )
}
